/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { SLTXFormatRootFileVariant } from '../../fileFormats/sltx/sltx';
import { TreeOptionSelections } from '../../modelConfiguration/data/optionsSelection';
import { ModelVariant } from './modelVariant';
import { CatalogTagsTranslation } from '../../modelViewer/Data/catalogTagsTranslation';
import { TranslationHelper } from '../utils/TranslationHelper';
import { SLTXUtil } from '../../fileFormats/sltx/sltxUtil';

interface ModelVariantsParameters {
  // Available variants of the model
  variants: SLTXFormatRootFileVariant[];
  // Current set of options selected by the user
  optionsSelectionState : TreeOptionSelections,
  // Translation of option tags
  tagsTranslation : CatalogTagsTranslation[],
  // Language Selected in the parent application
  languageSelected : string,
  // Function to update the options selection state
  updateOptionsSelectionState : (selection : TreeOptionSelections) => void,
  // Function to adjust the path to the resources like images
  getResourcePath : (path : string) => string,
}

export function ModelVariants({
  variants,
  optionsSelectionState,
  tagsTranslation,
  languageSelected,
  updateOptionsSelectionState,
  getResourcePath,
} : ModelVariantsParameters) : JSX.Element {

  const visibleVariants = variants.filter((v) => v.name !== SLTXUtil.DummyOption);
  return (
    <div className="model-variants container">
      {visibleVariants.map((variant) => {
        const translatedName = variant.name; // TODO PMC: Revisit if we want to translate variants
        return (
          <ModelVariant
            key={translatedName}
            variant={variant}
            optionsSelectionState={optionsSelectionState}
            updateOptionsSelectionState={updateOptionsSelectionState}
            getResourcePath={getResourcePath}
          />
        );
      })}
    </div>
  );
}
